@for (group of groups; track group) {
  <div class="form-check-inline">
    <input
      class="form-check-input me-1"
      [checked]="group.active"
      [id]="'group_' + group.id"
      (change)="handleChange(group.id, $event)"
      type="checkbox"
    />
    <label class="form-check-label" [for]="'group_' + group.id">
      @if (group.name !== '') {
        <span>{{ group.name }}</span>
      } @else {
        <span> <i class="far fa-star"></i> {{ 'phoneBook.contact.group.favourite' | portalTranslate }} </span>
      }
    </label>
  </div>
}
